import {WBCommonException} from './exception';

export class ServerException extends WBCommonException {
    public name = 'ServerException';

    constructor(public status: number, public message: string, public code?: string) {
        super(message);
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/providers/exception/entity/server.exception.ts